import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
/* empty css                 */
const DateAndTime = ({
  className,
  formattedDate,
  formattedTime,
  placeholder,
  ...rest
}) => {
  const showDateAndTime = formattedDate && formattedTime;
  const showPlaceholder = placeholder && (!formattedDate || !formattedTime);
  return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("date-and-time", className) }, /* @__PURE__ */ React.createElement(Icon, { name: "calendar", height: 32, width: 32 }), /* @__PURE__ */ React.createElement("div", null, showDateAndTime && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", { className: "date-and-time__line date-and-time__date-line" }, formattedDate), /* @__PURE__ */ React.createElement("p", { className: "date-and-time__line" }, formattedTime)), showPlaceholder && /* @__PURE__ */ React.createElement("p", { className: "date-and-time__line" }, placeholder)));
};
export {
  DateAndTime as default
};
//# sourceMappingURL=DateAndTime.js.map
